import { Pressable, StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { AppBottomSheet, BottomSheetScrollView } from '@/components/atoms';
import { useTranslation } from '@/i18n';

interface ContactNotesSheetProps {
  readonly visible: boolean;
  readonly contactName: string;
  readonly notes: string;
  readonly onDismiss: () => void;
}

const OUTLINE_COLOR = '#d5dfe6';
const NOTES_COLOR = '#1d1b20';

const styles = StyleSheet.create({
  header: {
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  title: {
    color: NOTES_COLOR,
    fontSize: 18,
    fontWeight: '700',
    textAlign: 'center',
  },
  divider: {
    backgroundColor: OUTLINE_COLOR,
    height: 1,
  },
  contentContainer: {
    paddingBottom: 32,
    paddingHorizontal: 16,
    paddingTop: 16,
  },
  notes: {
    color: NOTES_COLOR,
    fontSize: 14,
    lineHeight: 22,
  },
});

export const ContactNotesSheet = ({
  visible,
  contactName,
  notes,
  onDismiss,
}: ContactNotesSheetProps) => {
  const { t } = useTranslation();

  return (
    <AppBottomSheet visible={visible} snapPoints={['50%', '90%']} onDismiss={onDismiss}>
      <Pressable
        testID="contact-notes-sheet-dismiss-area"
        style={styles.header}
        onPress={onDismiss}>
        <Text style={styles.title}>{t('contacts.notesSheet.title', { name: contactName })}</Text>
      </Pressable>
      <View style={styles.divider} />
      <BottomSheetScrollView contentContainerStyle={styles.contentContainer}>
        <Text style={styles.notes}>{notes}</Text>
      </BottomSheetScrollView>
    </AppBottomSheet>
  );
};
